<template>
  <div>
    <v-card
      class="pt-3 px-5 pb-5"
      color="neutral-cold-057"
      flat
    >
      <!-- Delete roster btn -->
      <div class="text-center ml-3 delete-schedule">
        <v-menu
          offset-y
          :left="true"
        >
          <template v-slot:activator="{ on, attrs, value }">
            <v-btn
              v-show="tab === 'scheduleDetail'"
              dark
              depressed
              outlined
              height="32"
              color="primary-001"
              v-bind="attrs"
              v-on="on"
              class="more-features-btn"
              :class="{'more-features-btn-is-active': value}"
            >
              <span>{{ $t('PERMISSION.MORE_FEATURES') }}</span>
              <v-icon
                dark
                color="primary-001"
                size="20"
              >
                $vuetify.icons.arrowDownIcon
              </v-icon>
            </v-btn>
          </template>
          <v-list
            class="more-features-list"
          >
            <v-list-item
              link
              class="text-body-2 px-3"
              @click="clickExportBtn"
            >
              {{ $t('STAFF_MANAGEMENT.EXPORT_ROSTER') }}
            </v-list-item>
            <v-list-item
              link
              class="text-body-2 danger-021--text delete-roster-item px-3"
              active-class="neutral-040--text"
              @click="clickDeleteRosterBtn"
            >
              {{ $t('STAFF_MANAGEMENT.DELETE_SELECTED_ROSTER') }}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- <div
        v-show="tab === 'scheduleDetail' && scheduleDetailTable.selected.length !== 0"
        @click="openDeleteCheckModal()"
        class="delete-schedule"
      >
        <v-icon
          size="22"
          color="danger-022"
        >
          $vuetify.icons.trashCanIcon
        </v-icon>
        <p class="text-subtitle-4 danger-022--text mb-0">
          {{ $t('DELETE') }}
        </p>
      </div> -->
      <!-- Delete roster btn END-->

      <!-- Roster tabs -->
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary-001"
        class="schedule-report-tabs"
      >
        <v-tab
          class="text-subtitle-3 px-0 mr-10"
          active-class="neutral-040--text"
          key="scheduleRecord"
          href="#scheduleRecord"
        >
          {{ $t('STAFF_MANAGEMENT.UPLOAD_HISTORY') }}
        </v-tab>
        <v-tab
          class="text-subtitle-3 px-0"
          active-class="neutral-040--text"
          key="scheduleDetail"
          href="#scheduleDetail"
          @change="fetchScheduleDetail"
        >
          {{ $t('STAFF_MANAGEMENT.VIEW_ROSTER') }}
        </v-tab>
      </v-tabs>
      <!-- Roster tabs END -->
      <div>
        <v-tabs-items
          v-model="tab"
          class="v-tabs-bg"
        >
          <!-- Upload history -->
          <v-tab-item
            key="scheduleRecord"
            value="scheduleRecord"
          >
            <div class="d-flex">
              <Select
                :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_SHOP')"
                v-model="scheduleRecordTable.locationCode"
                :items="scheduleRecordShopLocations"
                @change="fetchStaffScheduleRecord()"
                item-text="name"
                item-value="code"
                solo
                flat
                class="schedule-record-tool mb-5"
              />

              <Select
                :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_MONTH')"
                v-model="scheduleRecordTable.month"
                :items="scheduleRecordMonthList"
                @change="fetchStaffScheduleRecord()"
                solo
                flat
                class="schedule-record-tool"
                item-text="text"
                item-value="value"
              />

              <Input
                v-model="scheduleRecordTable.search"
                :placeholder="$t('SEARCH')"
                hide-details
                background-color="neutral-cold-058"
                class="schedule-record-tool"
              >
                <template v-slot:prepend-inner>
                  <v-icon
                    color="neutral-042"
                    size="18"
                  >
                    $vuetify.icons.searchIcon
                  </v-icon>
                </template>
              </Input>
            </div>
            <ScheduleRecordTable
              :is-loading-table="scheduleRecordTable.isLoadingTable"
              :search="scheduleRecordTable.search"
              :list="scheduleRecordTable.list"
              :has-new-schedule-record="scheduleRecordTable.hasNewScheduleRecord"
            />
          </v-tab-item>
          <!-- Upload history END-->
          <!-- View Roster -->
          <v-tab-item
            key="scheduleDetail"
            value="scheduleDetail"
          >
            <div class="d-flex">
              <Select
                :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_SHOP')"
                v-model="scheduleDetailTable.currentShopLocationType"
                :items="scheduleDetailShopLocationTypes"
                @change="changeShopLocationType()"
                item-text="name"
                item-value="code"
                solo
                flat
                class="schedule-detail-tool mb-5"
              />
              <MultiAutoComplete
                :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_SHOP')"
                v-model="scheduleDetailTable.locationCode"
                :items="currentUserDict.shopLocations"
                @change="fetchScheduleDetail()"
                item-text="name"
                item-value="code"
                solo
                flat
                class="schedule-detail-tool schedule-detail-locationCode-select"
                width="231"
                multiple
                :disabled="scheduleDetailTable.currentShopLocationType !== 'select_shop'"
              />
              <Select
                :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_MONTH')"
                v-model="scheduleDetailTable.month"
                :items="monthRangeHistory"
                @change="fetchScheduleDetail()"
                solo
                flat
                min-width="237"
                class="schedule-detail-tool"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-title
                    class="text-body-2"
                  >
                    {{ item }}
                  </v-list-item-title>
                </template>
              </Select>
              <Input
                v-model="scheduleDetailTable.search"
                :placeholder="$t('SEARCH')"
                hide-details
                background-color="neutral-cold-058"
                class="schedule-detail-tool"
                width="231"
              >
                <template v-slot:prepend-inner>
                  <v-icon
                    color="neutral-042"
                    size="18"
                  >
                    $vuetify.icons.searchIcon
                  </v-icon>
                </template>
              </Input>
            </div>
            <ScheduleDetailTable
              :headers="staffScheduleDetailHeaders"
              :is-loading-table="scheduleDetailTable.isLoadingTable"
              :search="scheduleDetailTable.search"
              :list="scheduleDetailTable.list"
              :selected.sync="scheduleDetailTable.selected"
            />
          </v-tab-item>
          <!-- View Roster END -->
        </v-tabs-items>
      </div>
    </v-card>
    <Modal
      ref="emptyModal"
    >
      <template v-slot:actions>
        <v-card-actions class="pa-0 pt-8">
          <v-spacer />
          <v-btn
            color="primary-001"
            dark
            depressed
            @click="$refs.emptyModal.closeModal()"
            class="text-body-2"
          >
            {{ $t('CONFIRM') }}
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
    <Modal
      ref="deleteModal"
    >
      <template v-slot:actions>
        <v-card-actions class="pa-0 pt-8">
          <v-spacer />
          <v-btn
            color="neutral-045"
            outlined
            @click="$refs.deleteModal.closeModal()"
            class="text-body-2 cancel-btn"
          >
            {{ $t('CANCEL') }}
          </v-btn>
          <v-btn
            color="danger-022"
            outlined
            :loading="isDeleteBtnLoading"
            @click="deleteSchedule"
            class="text-body-2 ml-3"
          >
            {{ $t('DELETE') }}
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
    <Notification
      ref="notification"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Input from '@/components/form/Input.vue';
import Select from '@/components/form/Select.vue';
import MultiAutoComplete from '@/components/form/MultiAutoComplete.vue';
import Modal from '@/components/Modal.vue';
import { ROLE } from '@/utils/constants';
import { groupBy, createAndDownloadCSVFile } from '@/utils';
import staffApi from '@/restapis/staffManagement';
import staffApiV2 from '@/restapis/staffManagementV2';

import ScheduleRecordTable from './ScheduleRecordTable.vue';
import ScheduleDetailTable from './ScheduleDetailTable.vue';

export default {
  name: 'StaffScheduleReport',
  components: {
    Input,
    Select,
    MultiAutoComplete,
    Modal,
    ScheduleRecordTable,
    ScheduleDetailTable
  },
  props: {

  },
  data() {
    return {
      isDeleteBtnLoading: false,
      tab: 'scheduleRecord',
      currentMonthDays: [],
      monthRangeHistory: [],
      scheduleRecordTable: {
        isLoadingTable: false,
        list: [],
        count: 10,
        page: 0,
        pageSize: 100000,
        locationCode: '',
        month: '',
        search: '',
        hasNewScheduleRecord: false
      },
      scheduleDetailTable: {
        isLoadingTable: false,
        list: [],
        count: 10,
        page: 0,
        pageSize: 100000,
        locationCode: [],
        month: this.dayjs().add(0, 'month').format('YYYY-MM'),
        search: '',
        currentShopLocationType: '',
        selected: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict,
      lang: (state) => state.lang
    }),
    scheduleRecordShopLocations() {
      const shopLocationList = [...this.currentUserDict.shopLocations];
      if (this.currentUserDict.role === ROLE.ADMIN
      || this.currentUserDict.role === ROLE.MANAGER) {
        shopLocationList.unshift({ name: this.$t('STAFF_MANAGEMENT.ALL_SHOP'), code: '' });
      }
      return shopLocationList;
    },
    scheduleDetailShopLocationTypes() {
      return [
        { name: this.$t('STAFF_MANAGEMENT.ALL_SHOP'), code: '' },
        { name: this.$t('STAFF_MANAGEMENT.SELECT_SHOP'), code: 'select_shop' }
      ];
    },
    scheduleDetailShopLocations() {
      return this.currentUserDict.shopLocations;
    },
    scheduleRecordMonthList() {
      const allMonth = { text: this.$t('STAFF_MANAGEMENT.ALL_MONTH'), value: '' };
      const monthList = this.monthRangeHistory.map((month) => ({
        text: month,
        value: month
      }));
      return [allMonth, ...monthList];
    },
    staffScheduleDetailHeaders() {
      const list = [];
      this.currentMonthDays.forEach((day, index) => {
        list.push({
          text: `${index + 1}-in`,
          value: `${index + 1}-in`,
          class: 'text-body-2 neutral-042--text',
          sortable: false,
          width: '60px'
        });
        list.push({
          text: `${index + 1}-out`,
          value: `${index + 1}-out`,
          class: 'text-body-2 neutral-042--text',
          sortable: false,
          width: '60px'
        });
      });

      return [
        {
          text: this.$t('STAFF_MANAGEMENT.EMPLOYEE'),
          sortable: true,
          value: 'name',
          class: 'text-body-2 neutral-042--text first-col',
          width: '133px'
        },
        ...list

      ];
    }
  },
  mounted() {
    this.calculateMonthRangeSelection();
    this.fetchStaffScheduleRecord();
    this.resetCurrentMonthDays();
  },
  methods: {
    calculateMonthRangeSelection() {
      // monthRangeUpload last 3, future 3
      for (let i = 3; i >= 0; i--) {
        this.monthRangeHistory.push(this.dayjs().add(i, 'month').format('YYYY-MM'));
      }
      for (let i = 1; i <= 12; i++) {
        this.monthRangeHistory.push(this.dayjs().subtract(i, 'month').format('YYYY-MM'));
      }
    },
    async fetchStaffScheduleRecord(isNewUpload = false) {
      const params = {
        page: this.scheduleRecordTable.page,
        sizePerPage: this.scheduleRecordTable.pageSize,
        locationCode: this.scheduleRecordTable.locationCode,
        month: this.scheduleRecordTable.month
      };

      try {
        this.scheduleRecordTable.isLoadingTable = true;
        const response = await staffApi.getStaffScheduleRecord(params);

        this.scheduleRecordTable.count = response.data.data.total;

        const recordList = response.data.data.list;
        this.scheduleRecordTable.list = recordList.map((recordItem) => {
          recordItem.locationName = this.getLocationNameFromCode(recordItem.locationCode);
          return recordItem;
        });

        this.scheduleRecordTable.isLoadingTable = false;
      } catch (error) {
        this.scheduleRecordTable.isLoadingTable = false;
      }
    },
    changeShopLocationType() {
      if (this.scheduleDetailTable.currentShopLocationType === 'select_shop') return;
      this.fetchScheduleDetail();
    },
    async fetchScheduleDetail() {
      this.scheduleDetailTable.selected = [];
      const params = {
        page: 1,
        sizePerPage: 100000,
        month: this.scheduleDetailTable.month
      };

      if (this.scheduleDetailTable.currentShopLocationType === 'select_shop') {
        params.locationCode = this.scheduleDetailTable.locationCode.join();
      } else {
        params.locationCode = '';
      }

      try {
        this.scheduleDetailTable.isLoadingTable = true;
        const response = await staffApi.getStaffScheduleDetail(params);

        this.resetCurrentMonthDays();
        this.scheduleDetailTable.list = this.generateScheduleDetailTableData(response.data.data.list);

        this.scheduleDetailTable.isLoadingTable = false;
      } catch (error) {
        this.scheduleDetailTable.isLoadingTable = false;
      }
    },
    getLocationNameFromCode(code) {
      const targetShop = this.currentUserDict.shopLocations.find((shop) => shop.code === code);
      return targetShop ? targetShop.name : '';
    },
    resetCurrentMonthDays() {
      // 產生目前選擇要查詢的班表月份的所有日期
      this.currentMonthDays = [];
      const a = this.dayjs(this.scheduleDetailTable.month).date(1);
      const b = this.dayjs(a).add(1, 'M').date(0);

      // If you want an inclusive end date (fully-closed interval)
      for (let m = this.dayjs(a); m.diff(b, 'd') <= 0; m = m.add(1, 'd')) {
        this.currentMonthDays.push(this.dayjs(m));
      }
    },
    generateScheduleDetailTableData(rawData) {
      /*
          1. 分人員
          2. 算月份
       */
      if (rawData.length === 0) return [];
      const dataGroupByEmployee = groupBy(rawData, 'username');
      const tableData = [];

      Object.keys(dataGroupByEmployee).forEach((username, index) => {
        // array of 上班日期 for one employee
        const employeeScheduleData = dataGroupByEmployee[username];
        const rowData = { userId: username, name: employeeScheduleData[0].employeeName };
        let dayCounter = 1;
        this.currentMonthDays.forEach((date) => {
          //
          const dateString = date.format('YYYY-MM-DD');
          const availableDateData = employeeScheduleData.find((data) => data.clockInTime.includes(dateString));

          if (availableDateData) {
            rowData[`${dayCounter}-in`] = this.dayjs(availableDateData.clockInTime).format('HH:mm');
            rowData[`${dayCounter}-out`] = this.dayjs(availableDateData.clockOutTime).format('HH:mm');
          } else {
            rowData[`${dayCounter}-in`] = '';
            rowData[`${dayCounter}-out`] = '';
          }
          dayCounter++;
        });
        tableData.push(rowData);
      });
      return tableData;
    },
    clickExportBtn() {
      if (this.scheduleDetailTable.list.length === 0) {
        const title = this.$t('STAFF_MANAGEMENT.NO_ROSTER_FOR_SELECTED_MONTH');
        this.$refs.emptyModal.openModal(title, '');
        return;
      }
      this.exportRecords();
    },
    async exportRecords() {
      try {
        const params = {
          month: this.scheduleDetailTable.month,
          lang: 'en',
          locationCode: ''
        };
        if (this.scheduleDetailTable.currentShopLocationType === 'select_shop') {
          params.locationCode = this.scheduleDetailTable.locationCode.join();
        }
        if (this.lang === 'zhHant') {
          params.lang = 'zh';
        }

        const response = await staffApiV2.exportStaffSchedule(params);
        if (response.data.content) {
          const filename = `${this.scheduleDetailTable.month}-roster.csv`;
          createAndDownloadCSVFile(response.data.content, filename);
        }
      } catch (error) {
        console.log(error);
        const notificationObj = {
          title: this.$t('STAFF_MANAGEMENT.FAILED_TO_EXPORT_ROSTER')
        };
        this.$refs.notification.openNotification(notificationObj);
      }
    },
    clickDeleteRosterBtn() {
      const selectedRosterList = this.scheduleDetailTable.selected;
      if (selectedRosterList.length === 0) {
        return this.openEmptyCheckModal();
      }
      return this.openDeleteCheckModal();
    },
    openEmptyCheckModal() {
      const title = this.$t('STAFF_MANAGEMENT.SELECT_AT_LEAST_ONE_STAFF');
      this.$refs.emptyModal.openModal(title, '');
    },
    openDeleteCheckModal() {
      const userNameList = this.scheduleDetailTable.selected.map((user) => user.name).join();

      const title = this.$t('STAFF_MANAGEMENT.CHECK_DELETE_ROSTER').replace('{rosters}', `${userNameList}: ${this.scheduleDetailTable.month}`);
      this.$refs.deleteModal.openModal(title, '');
    },
    async deleteSchedule() {
      const userIdList = this.scheduleDetailTable.selected.map((user) => user.userId);
      const payload = {
        scheduleMonthList: [this.scheduleDetailTable.month],
        locationCodeList: this.scheduleDetailTable.locationCode,
        usernameList: userIdList
      };

      try {
        this.isDeleteBtnLoading = true;
        const { data } = await staffApi.deleteStaffSchedule(payload);
        if (data.success) {
          const notificationObj = {
            title: this.$t('STAFF_MANAGEMENT.ROSTER_IS_DELETED'),
            status: 'success'
          };
          this.$refs.notification.openNotification(notificationObj);
        }
        this.fetchScheduleDetail();
        this.$refs.deleteModal.closeModal();
        this.isDeleteBtnLoading = false;
      } catch (error) {
        const { code, message } = error.response.data;
        const notificationObj = {
          title: this.$t('ERROR_MSG.DELETE_FAIL'),
          content: `${code}-${message}`
        };
        this.$refs.notification.openNotification(notificationObj);
        this.isDeleteBtnLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

::v-deep.schedule-report-tabs {
  margin-bottom: 9px;
  .v-slide-group__content, .v-tab{
    height: 30px;
  }
  .v-tab {
    color: $neutral-cold-051;
    min-width: 72px;
    text-transform: none;
  }
}

.delete-schedule {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 3;
  > :not(:last-child) {
    margin-right: 6.5px;
  }
}

.schedule-record-tool {
  width: 237px;
  &:not(:last-child) {
    margin-right: 20px;
  }
}

.schedule-detail-tool {
  &:not(:last-child) {
    margin-right: 20px;
  }
  &:nth-child(odd){
    width: 128px;
  }
  &:nth-child(even){
    width: 215px;
  }
}

::v-deep.schedule-detail-locationCode-select {
  max-width: 237px;
  .v-autocomplete.v-select--is-multi .v-input__append-inner {
    position: absolute;
    right: 0;
    top: 0;
  }
}

::v-deep.v-tabs-bg.v-tabs-items  {
  background-color: transparent;
}

::v-deep.cancel-btn {
  .v-btn__content {
    color: $neutral-cold-051;
  }
}

.more-features-btn {
  .v-icon {
    transition: 0.3s;
  }
  &.more-features-btn-is-active {
    .v-icon {
      transform: rotate(-180deg);
    }
  }
}

.more-features-list {
  padding: 6px;
}

.delete-roster-item {
  &:hover::before {
    background-color: $neutral-040;
  }
}

</style>
